/**
 * @fileoverview gRPC-Web generated client stub for position
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.3
// source: src/grpc/position.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.position = require('./position_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.position.PositionClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.position.PositionPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.position.PositionReply>}
 */
const methodDescriptor_Position_GetPosition = new grpc.web.MethodDescriptor(
  '/position.Position/GetPosition',
  grpc.web.MethodType.SERVER_STREAMING,
  google_protobuf_empty_pb.Empty,
  proto.position.PositionReply,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.position.PositionReply.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.position.PositionReply>}
 *     The XHR Node Readable Stream
 */
proto.position.PositionClient.prototype.getPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/position.Position/GetPosition',
      request,
      metadata || {},
      methodDescriptor_Position_GetPosition);
};


/**
 * @param {!proto.google.protobuf.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.position.PositionReply>}
 *     The XHR Node Readable Stream
 */
proto.position.PositionPromiseClient.prototype.getPosition =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/position.Position/GetPosition',
      request,
      metadata || {},
      methodDescriptor_Position_GetPosition);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.position.PositionReply>}
 */
const methodDescriptor_Position_ListPosition = new grpc.web.MethodDescriptor(
  '/position.Position/ListPosition',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.position.PositionReply,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.position.PositionReply.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.position.PositionReply)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.position.PositionReply>|undefined}
 *     The XHR Node Readable Stream
 */
proto.position.PositionClient.prototype.listPosition =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/position.Position/ListPosition',
      request,
      metadata || {},
      methodDescriptor_Position_ListPosition,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.position.PositionReply>}
 *     Promise that resolves to the response
 */
proto.position.PositionPromiseClient.prototype.listPosition =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/position.Position/ListPosition',
      request,
      metadata || {},
      methodDescriptor_Position_ListPosition);
};


module.exports = proto.position;

